import api from "../api";

export const workspaceService = {
  async context() { return (await api.get("/workspace-context")).data; },
  async list() {
    const [projects, diagrams] = await Promise.all([api.get("/projects"), api.get("/diagrams")]);
    return { projects: projects.data, diagrams: diagrams.data };
  },
  async createProject(payload) { return (await api.post("/projects", payload)).data; },
  async createDiagram(payload) { return (await api.post("/diagrams", payload)).data; },
  deleteProject(id, password) { return api.delete(`/projects/${id}`, { data: { password } }); },
  deleteDiagram(publicId) { return api.delete(`/diagrams/${encodeURIComponent(publicId)}`); },
  async createWorkspace(payload) { return (await api.post("/workspaces", payload)).data; },
  async updateWorkspace(id, payload) { return (await api.patch(`/workspaces/${id}`, payload)).data; },
  deleteWorkspace(id) { return api.delete(`/workspaces/${id}`); },
  async dashboard(id) { return (await api.get(`/workspaces/${id}/dashboard`)).data; },
  async members(id) { return (await api.get(`/workspaces/${id}/members`)).data; },
  async addMember(id, payload) { return (await api.post(`/workspaces/${id}/members`, payload)).data; },
  async invitations(id) { return (await api.get(`/workspaces/${id}/invitations`)).data; },
  revokeInvitation(id, publicId) { return api.delete(`/workspaces/${id}/invitations/${encodeURIComponent(publicId)}`); },
  async resendInvitation(id, publicId) { return (await api.post(`/workspaces/${id}/invitations/${encodeURIComponent(publicId)}/resend`)).data; },
  async myInvitations() { return (await api.get("/workspace-invitations")).data; },
  async respondInvitation(publicId, decision) { return (await api.post(`/workspace-invitations/${encodeURIComponent(publicId)}/${decision}`)).data; },
  async updateMember(id, memberId, payload) { return (await api.patch(`/workspaces/${id}/members/${memberId}`, payload)).data; },
  removeMember(id, memberId) { return api.delete(`/workspaces/${id}/members/${memberId}`); },
  async trash() { return (await api.get("/trash")).data; },
  restoreTrash(type, id) { return api.post(`/trash/${type}/${id}/restore`); },
  deleteTrash(type, id, password) { return api.delete(`/trash/${type}/${id}`, { data: { password } }); },
};
